<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-button type="primary" plain icon="el-icon-plus" @click="openAddVisit()">新建探视预约</el-button>
      <el-input v-model="searchName" prefix-icon="el-icon-search" placeholder="输入探视人姓名" style="width: 250px"></el-input>
      <el-date-picker v-fixZoom :clearable="false" v-model="sendDate" type="daterange" unlink-panels
        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
        value-format="yyyy-MM-dd" style="margin-right: 10px; width: 400px">
      </el-date-picker>
      <el-button type="success" @click="getSearchData">查询</el-button>
    </div>
    <div style="height: calc(100% - 120px);margin: 0 20px">
      <el-table :data="tableData" border highlight-current-row ref="singleTable" height="100%">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          label="预约时间"
          width="100"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.confirm_esp_id !== 0 ? scope.row.actual_time : scope.row.v_time}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="toname"
          label="探视对象"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="toroom"
          label="探视房间"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="bed_name"
          label="探视床位"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="探视人"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="探视人电话"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="relationship"
          label="关系"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          label="探视人数"
          min-width="100"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.confirm_esp_id !== 0 ? scope.row.actual_pcnt : scope.row.v_pcnt}}人</span>
          </template>
        </el-table-column>
        <el-table-column
          label="探视状态"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <div :style="{backgroundColor: scope.row.confirm_esp_id !== 0 ? 'green' : 'red', color: '#ffffff'}">
              {{scope.row.confirm_esp_id !== 0 ? '已探视' : '未探视'}}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="380">
          <template slot-scope="scope">
            <el-button v-if="scope.row.device_id !== ''" size="mini" type="warning" plain @click="openVideo(scope.row)">拨打视频</el-button>
            <el-button v-if="scope.row.confirm_esp_id !== 0" size="mini" type="primary" plain @click="openViewVisit(scope.row)">详情</el-button>
            <el-button v-if="scope.row.confirm_esp_id === 0" size="mini" type="success" plain @click="openConfirmVisit(scope.row)">探视确认</el-button>
            <el-button v-if="scope.row.confirm_esp_id === 0" size="mini" type="primary" plain @click="openEditVisit(scope.row)">修改</el-button>
            <el-button v-if="scope.row.confirm_esp_id === 0" size="mini" type="danger" plain @click="delVisit(scope.row)">取消探视</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ titleShow }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-visit v-model="addEditShow" :visitObj="visitObj" @updateTable="updateTable"></add-edit-visit>
    </el-dialog>
    <el-dialog :visible.sync="videoShow" v-if="videoShow" width="900px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>探访视频</span>
        <div class="line-title"></div>
        <visit-video v-model="videoShow" :visitObj="visitObj"></visit-video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {accomodationgetbedvisit, accomodationupdatebedvisit} from '../../api/yanglaoyuan/homebed'
import AddEditVisit from './components/addEditVisit'
import visitVideo from './components/visitVideo'
export default {
  name: 'visitManagement',
  components: {AddEditVisit, visitVideo},
  data () {
    return {
      entityId: 0,
      espId: 0,
      espName: '',
      searchName: '',
      sendDate: [],
      pickerOptions: {
        // disabledDate (time) {
        //   return time.getTime() > Date.now()
        // },
        shortcuts: []
      },
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,

      tableData: [],
      addEditShow: false,
      titleShow: '',
      visitObj: {
        openType: 0,
        row: ''
      },
      videoShow: false
    }
  },
  created () {
    let loginResp = this.$store.state.user.LoginResp
    this.entityId = loginResp.entity_id
    this.espId = loginResp.syspersonid
    this.espName = loginResp.personname
    this.getTimeObj()
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let start = new Date().format('yyyy-MM-dd')
    const end = this.commonType.GetDateStr(30)
    this.sendDate = [start, end.format('yyyy-MM-dd')]
    this.getSearchData()
  },
  methods: {
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    },

    openAddVisit () {
      this.titleShow = '新建探视预约'
      this.visitObj.row = ''
      this.visitObj.openType = 1
      this.addEditShow = true
    },
    openEditVisit (row) {
      this.titleShow = '修改探视预约'
      this.visitObj.row = row
      this.visitObj.openType = 2
      this.addEditShow = true
    },
    openConfirmVisit (row) {
      this.titleShow = '探视确认'
      this.visitObj.row = row
      this.visitObj.openType = 3
      this.addEditShow = true
    },
    openViewVisit (row) {
      this.titleShow = '详情'
      this.visitObj.row = row
      this.visitObj.openType = 0
      this.addEditShow = true
    },
    openVideo (row) {
      this.visitObj.row = row
      this.videoShow = true
    },
    delVisit (row) {
      this.$confirm('此操作将取消该探视预约, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          oper_type: 2,
          id: row.id,
          eid: row.eid,
          apply_esp_id: this.espId,
          apply_esp_name: this.espName
        }
        accomodationupdatebedvisit(data).then(res => {
          this.$notify({title: '成功', message: '成功取消预约探视', type: 'success', duration: 2000})
          this.updateTable()
        })
      })
    },
    getSearchData () {
      this.getHomeBedVisitData()
    },
    updateTable () {
      this.getSearchData()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getSearchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getSearchData()
    },

    // 访问接口
    // 查询探视记录
    getHomeBedVisitData () {
      this.tableData = []
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        eid: this.entityId === 0 ? -1 : this.entityId,
        vistor_name: this.searchName,
        time_flag: 1,
        start_time: this.sendDate[0] + ' 00:00:00',
        end_time: this.sendDate[1] + ' 23:59:59'
      }
      accomodationgetbedvisit(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.arrdata
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/visitManagement.vue